import React, { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useData } from '../contexts/DataContext';
import Loading from '../components/Loading';
import './Portfolio.css';

const Portfolio = () => {
  const { portfolioItems, portfolioCategories, getPortfolioItemsByCategory, loading } = useData();
  const [selectedCategory, setSelectedCategory] = useState('');

  // Filter portfolio items based on selected category
  const filteredItems = useMemo(() => {
    if (loading) return [];
    return getPortfolioItemsByCategory(selectedCategory);
  }, [loading, selectedCategory, getPortfolioItemsByCategory]);

  return (
    <div className="portfolio-page">
      <section className="page-header">
        <div className="container">
          <h1>Portofoliu</h1>
          <p>Descoperă lucrările noastre realizate</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          {/* Category Filter */}
          <div className="filter-section">
            <button
              className={`filter-btn ${selectedCategory === '' ? 'active' : ''}`}
              onClick={() => setSelectedCategory('')}
            >
              Toate Lucrările
            </button>
            {portfolioCategories.map(category => (
              <button
                key={category.id}
                className={`filter-btn ${selectedCategory === category.slug ? 'active' : ''}`}
                onClick={() => setSelectedCategory(category.slug)}
              >
                {category.name}
              </button>
            ))}
          </div>

          {/* Portfolio Grid */}
          {loading ? (
            <Loading />
          ) : filteredItems.length > 0 ? (
            <div className="grid grid-3">
              {filteredItems.map(item => (
                <Link to={`/portfolio/${item.slug}`} key={item.id} className="portfolio-card card">
                  {item.featured_image && (
                    <img src={item.featured_image} alt={item.title} />
                  )}
                  <div className="card-content">
                    <h3>{item.title}</h3>
                    <p className="category">{item.category_name}</p>
                    {item.type && <p className="type">Tip: {item.type}</p>}
                    <p className="description">{item.description.substring(0, 100)}...</p>
                  </div>
                </Link>
              ))}
            </div>
          ) : (
            <p className="no-data">Nu au fost găsite lucrări pentru această categorie.</p>
          )}
        </div>
      </section>
    </div>
  );
};

export default Portfolio;

